<template>
  <Modal
    ref="modalRef"
    title=""
    :show-icon="false"
    :click-to-close="true"
    with-closer
    positive-action-text="Komisyon Kampanyalarına Git"
    negative-action-text=""
    :modal-style="{ width: '460px' }"
    @on-positive-action-click="goToCampaigns"
  >
    <template #body>
      <div class="campaign-ended-modal">
        <div class="campaign-ended-modal-icon">
          <div class="campaign-ended-modal-icon-circle">
            i
          </div>
        </div>
        <h3 class="campaign-ended-modal-title">
          İlgili kampanyamız sona erdi
        </h3>
        <p class="campaign-ended-modal-text">
          Mağazanız için yeni
          <strong>Kategori Komisyon İndirimi Kampanyalarını</strong> keşfetmek
          ve avantajlı kampanyalara katılmak için sayfamızı ziyaret etmeyi
          unutmayın.
        </p>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Modal } from '@n11/so-ui-components';

const router = useRouter();
const modalRef = ref(null);

onMounted(() => {
  const { campaignEnded, ...restQuery } = router.currentRoute.value.query;
  if (campaignEnded !== 'true') return;
  router.replace({ query: restQuery });
  modalRef.value?.openModal?.();
});

const goToCampaigns = () => {
  modalRef.value?.hiddenModal?.();
  router.push({ name: 'CategoryCommissionCampaigns' });
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables';

.campaign-ended-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 8px 4px;
  gap: 16px;
  text-align: center;

  .campaign-ended-modal-icon {
    display: flex;
    justify-content: center;
    margin-top: 40px;

    .campaign-ended-modal-icon-circle {
      display: flex;
      width: 48px;
      height: 48px;
      align-items: center;
      justify-content: center;
      border-radius: 999px;
      background: $colorB50;
      color: #fff;
      font-size: 26px;
      font-weight: 700;
      line-height: 1;
    }
  }

  .campaign-ended-modal-title {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.2px;
    line-height: 26px;
  }

  .campaign-ended-modal-text {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: -0.05px;
    line-height: 24px;

    strong {
      font-weight: 700;
    }
  }
}
</style>
